import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Navcomp from './components/Navcomp';
import Footer from './components/Footer';


import Newsletter from './components/Newsletter';
import Specser from './components/Specser';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Tim from './pages/Tim';
import Grace from './pages/Grace';



function App() {
  return (
    <Router>
      <Navcomp />
      <Route exact path="/" component={Home} />
      <Route exact path="/about" component={About} />
      <Route exact path="/services" component={Services} />
      <Route exact path="/Projects" component={Projects} />
      <Route exact path="/Contact" component={Contact} />
      <Route exact path="/Tim" component={Tim} />
      <Route exact path="/Grace" component={Grace} />
      <Newsletter />
      <Footer />
    </Router>

  );
}

export default App;
